import { AuthService } from './authService';
import { extractApiError } from '../utils/apiError';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

export interface MaintenanceStatusDto {
    isScheduled: boolean;
    isActive: boolean;
    message: string | null;
    scheduledAtUtc: string | null;
    activatedBy: string | null;
}

export interface ActivateMaintenanceRequest {
    countdownMinutes: number;
    message?: string;
}

class MaintenanceService {
    async getStatus(): Promise<MaintenanceStatusDto> {
        const response = await AuthService.authenticatedGet(
            `${API_BASE_URL}/maintenance/status`
        );
        if (!response.ok) {
            throw new Error('Kunne ikke hente vedlikeholdsstatus');
        }
        return response.json();
    }

    async activate(request: ActivateMaintenanceRequest): Promise<MaintenanceStatusDto> {
        const response = await AuthService.authenticatedPost(
            `${API_BASE_URL}/maintenance/activate`,
            request
        );
        if (!response.ok) {
            const error = await response.json().catch(() => null);
            throw new Error(extractApiError(error, response, 'Kunne ikke aktivere vedlikeholdsmodus'));
        }
        return response.json();
    }

    async deactivate(): Promise<MaintenanceStatusDto> {
        const response = await AuthService.authenticatedPost(
            `${API_BASE_URL}/maintenance/deactivate`
        );
        if (!response.ok) {
            throw new Error('Kunne ikke deaktivere vedlikeholdsmodus');
        }
        return response.json();
    }
}

export const maintenanceService = new MaintenanceService();
